export const environment = {
  version: 0,
  APIBaseUrl: 'https://casadmin.pickright.in',
  token: 'marsAdminToken',
  routePrefix: 'cas'
};
